"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contact = void 0;
let Contact = exports.Contact = void 0;
(function (_Contact) {
  let Type = /*#__PURE__*/function (Type) {
    Type["PERSON"] = "person";
    Type["ORGANISATION"] = "organisation";
    return Type;
  }({});
  _Contact.Type = Type;
  let Gender = /*#__PURE__*/function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
    Gender["UNSPECIFIED"] = "unspecified";
    return Gender;
  }({});
  _Contact.Gender = Gender;
  let Periodicity = /*#__PURE__*/function (Periodicity) {
    Periodicity["DAILY"] = "daily";
    Periodicity["WEEKDAYS"] = "weekdays";
    Periodicity["WEEKLY"] = "weekly";
    Periodicity["BI_WEEKLY"] = "bi-weekly";
    Periodicity["MONTHLY"] = "monthly";
    Periodicity["BI_MONTHLY"] = "bi-monthly";
    Periodicity["QUARTERLY"] = "quarterly";
    Periodicity["ANNUALLY"] = "annually";
    Periodicity["BI_ANUALLY"] = "bi-annually";
    Periodicity["SEMI_ANNUALLY"] = "semi-annually";
    return Periodicity;
  }({});
  _Contact.Periodicity = Periodicity;
  let MediumType = /*#__PURE__*/function (MediumType) {
    MediumType["WIRE"] = "wire";
    MediumType["PRINT"] = "print";
    MediumType["RADIO"] = "radio";
    MediumType["PHOTO"] = "photo";
    MediumType["NEWSPAPER"] = "newspaper";
    MediumType["MAGAZINE"] = "magazine";
    MediumType["TV"] = "tv";
    MediumType["BLOG"] = "blog";
    MediumType["VLOG"] = "vlog";
    MediumType["SOCIAL"] = "social";
    MediumType["WEB"] = "web";
    MediumType["ANALYST"] = "analyst";
    MediumType["EXPERT"] = "expert";
    MediumType["INFLUENCER"] = "influencer";
    MediumType["PODCAST"] = "podcast";
    MediumType["NEWSLETTER"] = "newsletter";
    MediumType["NEWS_SITE"] = "news website";
    return MediumType;
  }({});
  _Contact.MediumType = MediumType;
  let SocialNetwork = /*#__PURE__*/function (SocialNetwork) {
    SocialNetwork["DISCORD"] = "discord";
    SocialNetwork["FACEBOOK"] = "facebook";
    SocialNetwork["INSTAGRAM"] = "instagram";
    SocialNetwork["LINKEDIN"] = "linkedin";
    SocialNetwork["PINTEREST"] = "pinterest";
    SocialNetwork["SKYPE"] = "skype";
    SocialNetwork["SNAPCHAT"] = "snapchat";
    SocialNetwork["TIKTOK"] = "tiktok";
    SocialNetwork["TWITCH"] = "twitch";
    SocialNetwork["TWITTER"] = "twitter";
    SocialNetwork["YOUTUBE"] = "youtube";
    return SocialNetwork;
  }({});
  _Contact.SocialNetwork = SocialNetwork;
  let PhoneNumber;
  (function (_PhoneNumber) {
    let Type = /*#__PURE__*/function (Type) {
      Type["TELEPHONE"] = "tel";
      Type["CELLPHONE"] = "cell";
      return Type;
    }({});
    _PhoneNumber.Type = Type;
  })(PhoneNumber || (PhoneNumber = _Contact.PhoneNumber || (_Contact.PhoneNumber = {})));
  function isPerson(arg) {
    if (arg !== null && typeof arg === 'object') {
      return arg.contact_type === Type.PERSON;
    }
    return arg === Type.PERSON;
  }
  _Contact.isPerson = isPerson;
  function isOrganisation(arg) {
    if (arg !== null && typeof arg === 'object') {
      return arg.contact_type === Type.ORGANISATION;
    }
    return arg === Type.ORGANISATION;
  }
  _Contact.isOrganisation = isOrganisation;
})(Contact || (exports.Contact = Contact = {}));